"use client";
import type { MicrocopySet } from "@lib/contentful/microcopy/types";
import { SharedMicrocopyProvider } from "@lib/contentful/microcopy/MicrocopyContext";
import type { ClientSiteSettings } from "@lib/contentful/types";
import React, { createContext, use } from "react";

interface GlobalContentContextType {
    siteSettings: ClientSiteSettings;
    sharedMicrocopySet: MicrocopySet | null;
    accessibilityStatementPath?: string;
}

const GlobalContentContext = createContext<GlobalContentContextType | undefined>(undefined);

export const GlobalContentProvider = ({
    children,
    siteSettings,
    sharedMicrocopySet,
    accessibilityStatementPath,
}: GlobalContentContextType & { children: React.ReactNode }) => {
    return (
        <GlobalContentContext
            value={{ siteSettings, sharedMicrocopySet, accessibilityStatementPath }}
        >
            <SharedMicrocopyProvider sharedMicrocopySet={sharedMicrocopySet}>
                {children}
            </SharedMicrocopyProvider>
        </GlobalContentContext>
    );
};

export const useGlobalContent = () => {
    const context = use(GlobalContentContext);
    if (!context) throw new Error("useGlobalContent must be used inside a GlobalContentProvider");
    return context;
};
